import React from "react";
import s from "../labReportPdf.module.scss";

const TyphoidReport = ({ profile, PageBaseLayout, PageFooter }) => {
  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout showSampleType={true} currentSampleType={profile.sampleType} />
      <div className={s.testCategoryHeader}>TYPHOID PROFILE TEST</div>

      <table className={s.resultsTable}>
        <thead>
          <tr>
            <th style={{ width: "45%" }}>Test Description</th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              colSpan="4"
              style={{ fontWeight: "bold", backgroundColor: "#f9f9f9" }}
            >
              SEROLOGY
            </td>
          </tr>
          {profile.tests.map((t, idx) => (
            <tr key={idx}>
              <td>
                <strong>{t.testName}</strong>
              </td>
              <td align="center">
                <span
                  style={{
                    fontWeight:
                      t.value?.toLowerCase() === "positive" ? "900" : "normal",
                  }}
                >
                  {t.value || ""}
                </span>
              </td>
              <td align="center">{t.units || ""}</td>
              <td align="center">{t.reference_range_details || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <PageFooter />
    </div>
  );
};

export default TyphoidReport;
